// extracted by mini-css-extract-plugin
export default {"TitleContainer":"Animation_TitleContainer__p+JBR","AnimationContainer":"Animation_AnimationContainer__CpTPj"};